export default __webpack_public_path__ + "static/media/rit.f248382d.pdf";